import styles from './LoadingModal.module.scss'
import { Backdrop, CircularProgress } from "@mui/material"

interface LoadingModalProps {
  title?: string
}

const LoadingModal = (props: LoadingModalProps) => {
  const {title='Загружаем...'} = props
  return (
    <Backdrop
      open
      className={styles.root}
    >
      <CircularProgress className={styles.loader}/>
      {title}
    </Backdrop>
  )
}

export default LoadingModal